@if (amDestination()?.holidayType === AmHolidayType.DP) {
  <div class="dates-selector-root relative fill grow separator">
    <ng-container>
      <fin-booking-widget-selector
        [disabled]="disabled()"
        (click)="openModal()"
        [double]="{
          first: {
            label: 'bookingSearch.boundSelection.departureDate' | finLocalization,
            placeholder: 'bookingSearch.boundSelection.selectDatePlaceholder' | finLocalization,
            filled: $safeNavigationMigration(travelDates()?.['departureDate']) !== undefined,
          },
          second: {
            label: 'bookingSearch.boundSelection.returnDate' | finLocalization,
            placeholder: 'bookingSearch.boundSelection.selectDatePlaceholder' | finLocalization,
            filled: $safeNavigationMigration(travelDates()?.['returnDate']) !== undefined,
          },
        }"
        [label]="'bookingSearch.boundSelection.departureDate' | finLocalization"
        [placeholder]="'bookingSearch.boundSelection.selectDatePlaceholder' | finLocalization"
        [filled]="$safeNavigationMigration(travelDates()?.['departureDate']) !== undefined"
        [attr.data-testid]="'am-dates-selector-both'"
      >
        @if (travelDates()?.['departureDate']; as selectedDate) {
          <span first data-testid="departure-date">{{ selectedDate | finDateFormat: 'FULL_NO_YEAR' }}</span>
        }
        <div
          separator
          class="flex flex--center flex--self-center absolute white-bg surface-primary date-spacer ps-xxsmall z1"
        >
          <fcom-icon class="icon-medium" [name]="SvgLibraryIcon.MINUS" />
        </div>
        @if (travelDates()?.['returnDate']; as selectedDate) {
          <span second data-testid="return-date">{{ selectedDate | finDateFormat: 'FULL_NO_YEAR' }}</span>
        }
      </fin-booking-widget-selector>
    </ng-container>
  </div>
} @else {
  <div>
    <div class="df-laptop-up">
      <fin-am-duration-selector
        [selectedDuration]="selectedDuration()"
        [durationOptions]="amDestination()?.holidayTypeItem?.items"
        (setDuration)="selectDuration($event)"
        class="flex flex--basis-half border-right"
      />
      <fin-booking-widget-selector
        class="flex flex-1"
        [disabled]="disabled()"
        [position]="'right'"
        [label]="'bookingSearch.boundSelection.departureDate' | finLocalization"
        [attr.data-testid]="'travel-dates-selector-am'"
        (click)="openModal()"
      >
        @if (travelDates()?.departureDate; as departureDate) {
          <span data-testid="departure-date">{{ departureDate | finDateFormat: 'FULL_NO_YEAR' }}</span>
        }
      </fin-booking-widget-selector>
    </div>
  </div>
}

<fcom-modal
  [open]="modalOpen"
  [fitToContent]="true"
  [buttons]="null"
  [fullHeight]="true"
  [extraWide]="true"
  [roundedContent]="true"
  (close)="closeModal()"
  data-testid="travel-dates-modal"
>
  <fcom-datepicker
    [uiLabels]="datepickerLabels$ | async"
    [dateLabels]="dateLabels$ | async"
    [titleAreaConfiguration]="{
      titleAreaStyle: 'ps-large-x ps-xsmall-y',
      title: datePickerTitleLabel() | finLocalization,
      titleStyle: 'font-heading-4 font-title-medium',
    }"
    [isDateRange]="amDestination()?.holidayType === AmHolidayType.DP"
    [selectableDatesRange]="calendarRange"
    [disabledDateRanges]="disabledDateRanges()"
    [selectedDates]="[travelDates()?.departureDate, travelDates()?.returnDate]"
    [doneBtnHidden]="true"
    [showTags]="false"
    [dayTemplate]="dayTemplate"
    (selectedDatesChange)="updateCalendarDates($event)"
    (close)="closeModal()"
  />

  <div
    class="df-tablet-up flex--middle ps-large-x grey-50-bg surface-disabled font-body-1 ps-small font-body-medium"
    [ngClass]="{
      'travel-dates-sticky-footer': datesSelected(),
    }"
    data-testid="travel-dates-footer"
  >
    <span class="flex flex--space-between fill travel-dates-footer-container">
      @if (amDestination()?.holidayType === AmHolidayType.AM) {
        <span class="flex flex--middle">
          <fcom-icon class="icon-medium ms-xsmall-r" [name]="SvgLibraryIcon.AM_LOGO" />
          <span>{{ 'aurinkomatkat.calendar.recommendedTravelDates' | finLocalization }}</span>
        </span>
      }
    </span>
    <div class="done-button align-center">
      <fcom-button
        [text]="'actions.done' | finLocalization"
        (clickBtn)="closeModal()"
        data-testid="date-modal-close-btn"
      />
    </div>
  </div>
</fcom-modal>

<ng-template #dayTemplate let-dayValue="dayValue" let-dayString="dayString">
  <div class="calendar-day" [attr.data-testid]="'calendar-day-' + dayValue.id">
    <div
      class="ps-xxsmall-t"
      [ngClass]="{ 'aurinkomatkat-orange-text': suggestedAmTravelDays().includes(dayValue.id) }"
    >
      {{ dayString }}
    </div>
  </div>
</ng-template>
